import { useMemo } from 'react';
import { SimpleBars } from '../../Common/Charts/SimpleBars';
import { useEpidemiologyChartsDataContext } from './hooks/useEpidemiologyChartsDataContext';

export const ByCidChapter = () => {
    const { chartData } = useEpidemiologyChartsDataContext();

    const { subtitles, values } = useMemo(() => {
        const items = (chartData?.epidemiologyByCidChapter || [])
            .slice()
            .sort(
                (a, b) =>
                    Number(b?.pct || 0) -
                    Number(a?.pct || 0)
            )
            .slice(0, 10);

        return {
            subtitles: items.map(
                (item) => item?.capitulo || 'Não informado'
            ),
            values: items.map(
                (item) => Number(item?.pct || 0)
            )
        };
    }, [chartData]);

    return (
        <SimpleBars
            title="Distribuição por Capítulo CID (%)"
            horizontal={true}
            subtitles={subtitles}
            values={values}
            height={420}
            showDataLabels={true}
        />
    );
};